import { FooterStore } from 'src/modules/footer/types';

import { AnyStore } from 'stores';

export const footerStore = new AnyStore<FooterStore>({
  slim: false,
});
